/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_TitleInputs */



/**
* | output |
* | --- |
* | "Pre-Render Frame Cache" |
*
* @param {Pre_Render_Frame_Cache_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_title = /** @type {((inputs?: Pre_Render_Frame_Cache_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pré-génération du cache d'images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorgerenderter Frame-Cache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cache dei frame di pre-rendering")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительно отрисованный кэш кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Precargar caché de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预渲染帧缓存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリレンダリングフレームキャッシュ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्री-रेंडर फ्रेम कैश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cache de quadros de pré-renderização")
	return /** @type {LocalizedString} */ ("Pre-Render Frame Cache")
});